import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { ProfileViewModel, JourneyViewModel } from "../types/ProfileViewModel";
import { CompleteProfileRequest } from "../types/CompleteProfileRequest";
import { AvailableAppointments } from "../types/AvailableAppointments";

export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.profileService}`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: builder => ({
    getProfileById: builder.query<ProfileViewModel, string>({
      query: profileId => {
        return `/profile/${profileId}`;
      },
    }),
    getJourneyById: builder.query<JourneyViewModel, { userId: string; journeyId: string }>({
      query: ({ userId, journeyId }) => {
        return `v2/profile/${userId}/journey/${journeyId}`;
      },
    }),
    getAppointments: builder.query<AvailableAppointments, string>({
      query: userId => {
        return `v2/profile/${userId}/appointments/gloji`;
      },
    }),
    completeProfile: builder.mutation<void, CompleteProfileRequest>({
      query(data) {
        return {
          url: `v2/profile/${data.userId}/journey/${data.journeyId}`,
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProfileByIdQuery,
  useGetJourneyByIdQuery,
  useGetAppointmentsQuery,
  useCompleteProfileMutation,
} = profileApi;
